export interface TimeEntryBreakDto {
  id: string;
  breakDuration: number;
  durationMinutes: number;
  breakStart: string;
  breakEnd: string | null;
  createdAt: string;
}

export interface RecordBreakDto {
  breakDuration?: number;
  breakStart?: string;
  breakEnd?: string;
}
